"use client";

import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { getRecoveryFlowConfig } from "../../services/federation/queries/transactions";
import { useRecoveryStore } from "../../state/stores/recovery";

export function useRecoveryFlowConfig() {
  const storedUseNewRecoveryFlow = useRecoveryStore((s) => s.useNewRecoveryFlow);
  const setUseNewRecoveryFlow = useRecoveryStore((s) => s.setUseNewRecoveryFlow);

  const query = useQuery({
    queryKey: ["getRecoveryFlowConfig"],
    queryFn: ({ signal }) => getRecoveryFlowConfig({ signal }),
    retry: false,
    staleTime: Number.POSITIVE_INFINITY,
  });

  useEffect(() => {
    if (query.data) {
      setUseNewRecoveryFlow(query.data.getRecoveryFlowConfig.useNewRecoveryFlow);
    }
  }, [query.data, setUseNewRecoveryFlow]);

  useEffect(() => {
    if (query.isError) {
      setUseNewRecoveryFlow(undefined);
    }
  }, [query.isError, setUseNewRecoveryFlow]);

  return {
    ...query,
    useNewRecoveryFlow: query.data?.getRecoveryFlowConfig.useNewRecoveryFlow ?? storedUseNewRecoveryFlow,
  };
}
